// 应用菜单
const menuData = {
  iconClass: "el-icon-s-home",
  menuName: "组织架构",
  children: [
    {
      path: "/rhqy/org/member",
      menuName: "通讯录",
      privilege: "c-contact-contact-sync",
      iconClass: "el-icon-user-solid"
    },
    {
      path: "/rhqy/org/label",
      menuName: "角色管理",
      privilege: "c-contact-tag-mgr&c-contact-tag-view",
      iconClass: "el-icon-user"
    }
  ]
};

export { menuData };
